import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SsoAuthenticationStartFailedAction = {
	type: 'SSO_AUTHENTICATION_START_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SsoAuthenticationStartFailedAction => ({
	type: 'SSO_AUTHENTICATION_START_FAILED',
	payload,
});
